import React from 'react';
import withState from '../../../../../utils/withState';
import {
  account$,
} from '../../../../../emitters/account';
import TextField from '../../../../dumb/TextField/A';
import Field from "../../../../dumb/Field/E";
import Ripple from "../../../../dumb/Ripple";
import {pushLocation} from "../../../../../router";
import {LINK_HELP} from "../../../../../constants/links";
const Caption = require("../../../../dumb/Caption/B");


module.exports = withState(() => {
  return (state, props) => {
    const disabled = props.disabled || false;
    const account = state.account || {};


    return (
      <>
        <Caption>
          Account Settings
        </Caption>
        <div
          className={`cfx mt20 mh-28 (w1/2|w@m|ph28|lt)>1 `
            + (props.className || '')}
        >
          <div>
            <TextField
              className="mb30"
              label="Company Name"
              value={(disabled ? account.fullname : account.company) || ''}
              disabled
            />
            <TextField
              className="mb30"
              label="Email"
              value={account.username || ''}
              disabled
            />
          </div>
          <div>
            <Field
              label="Change legal data"
            >
              <Ripple
                className="layoutRow fvaC fhaC h45 wmin120 bs b1 bc5B47FF c5B47FF r6
                      ttU olN f16 fw4 tdN ov"
                onClick={() => pushLocation({path: LINK_HELP})}
              >Contact us</Ripple>
            </Field>
          </div>
        </div>
      </>
    );
  };
}, {
  account: account$,
});
